import React from "react";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import Footer from "common/Footer";
import MDBox from "components/MDBox";
import LLMSettingsForm from "common/Settings/LLMSettings";
import { useCompany } from "context/CompanyContext";
import { useLanguage } from "context/LanguageContext";

function LLMSettings() {
  const { selectedCompany } = useCompany();
  const { t } = useLanguage();
  const companyId = selectedCompany?.id;

  return (
    <DashboardLayout>
      <MDBox py={3}>
        <MDBox mb={3}>
          {companyId ? (
            <LLMSettingsForm companyId={String(companyId)} />
          ) : (
            <MDBox textAlign="center" py={5}>
              {t("selectCompanyFirst")}
            </MDBox>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LLMSettings;
